export default "<div class=\"main-container\">\n  <topbar></topbar>\n</div>"